import { Button, FlexRow } from "@similarweb/ui-components";

import { AutomationTagGeneratorBase, generateAutomationName } from "../../../helpers/generateAutomationName";

import { ButtonIcon, ButtonsWrapper } from "./styles";
import type { ButtonConfigSchema } from "./types";
import { ButtonsAlignVariant } from "./types";

type ButtonsSchema = {
    closeButton: Partial<ButtonConfigSchema>;
    nextButton: Partial<ButtonConfigSchema>;
    backButton?: Partial<ButtonConfigSchema> | null;
    showCancelButton?: boolean;
    alignButtons?: React.CSSProperties["alignItems"];
};

const Buttons = ({
    closeButton,
    backButton,
    nextButton,
    showCancelButton = false,
    alignButtons = ButtonsAlignVariant.SpaceBetween,
}: ButtonsSchema) => (
    <ButtonsWrapper
        alignButtons={alignButtons}
        data-automation={generateAutomationName("home", ["setup", "buttons"], AutomationTagGeneratorBase.Activation)}
    >
        <div data-automation={generateAutomationName("activation", ["setup", "button-close"])}>
            {showCancelButton ? <Button {...closeButton} /> : null}
        </div>

        <FlexRow
            data-automation={generateAutomationName(
                "home",
                ["setup", "button-back-next"],
                AutomationTagGeneratorBase.Activation,
            )}
        >
            {backButton ? (
                <Button {...backButton}>
                    <ButtonIcon
                        iconName={backButton.iconName}
                        size="xs"
                    />
                </Button>
            ) : null}

            <Button {...nextButton} />
        </FlexRow>
    </ButtonsWrapper>
);

export default Buttons;
